module.exports = __webpack_public_path__ + "static/media/Ride1UpLogo.94b816ec.svg";